import React from "react";

/* eslint-disable */
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");

const Office365 = () => {
    const heading = `OFFICE 365`;
    const details = `Let us fully manage your Office 365 service.`;

    const overview = [
        `DETASAD can help you get the most from the agility, scalability and cost advantages that Office 365 provides to fully exploit its power with less risk. Office 365 delivers the right productivity tools that your team require for collaboration, mobility, reliability and security of your organization. We offer different plans of Office 365 and you can select it according to your requirements. Nearly 80% of IT pros surveyed said that they could save money and gain more productivity as a result of using a cloud approach. We don’t just move you to Office 365, we help businesses around the Kingdom to build innovative digital workplace solutions to reinvent productivity using Office 365.`
    ];

    const advantages = [
        [
            `Migration Assistance`,
            `Migration assistance from DETASAD technical professionals who know how to support your business.`,
            icon
        ],
        [`Onboarding`, `DETASAD offers Office 365 Onboarding to our users.`, icon],
        [
            `Support`,
            `Office 365 provided by DETASAD is backed by 24x7x365 support services which is always available for your help and assistance.`,
            icon
        ],
        [
            `Archiving`,
            `Our archiving solutions work seamlessly with Office 365, so you can secure your email with one email archiver solution.`,
            icon
        ]
    ];

    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-collab"/>
            <SubNav overview={overview} advantages={advantages} />
            <Footer />
        </div>
    );
};

export default Office365;
